import(/* webpackMode: "eager" */ "/Users/gokmenkarasu/Desktop/Claude/album-reviews/src/app/error.tsx");
